import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon48: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#FFD147"
        d="M2.93 2.926c3.898-3.901 10.242-3.901 14.14 0A9.939 9.939 0 0 1 20 10a9.943 9.943 0 0 1-2.93 7.075A9.967 9.967 0 0 1 10 20a9.967 9.967 0 0 1-7.07-2.925A9.943 9.943 0 0 1 0 10a9.939 9.939 0 0 1 2.93-7.074ZM10 1c-2.305 0-4.61.877-6.364 2.633A8.945 8.945 0 0 0 1 10c0 2.405.936 4.665 2.636 6.366 3.509 3.512 9.219 3.512 12.728 0A8.945 8.945 0 0 0 19 10a8.945 8.945 0 0 0-2.636-6.367A8.967 8.967 0 0 0 10 1Zm4.65 10.836a.5.5 0 1 1 .93.367A5.969 5.969 0 0 1 10 15.996a5.97 5.97 0 0 1-5.581-3.793.5.5 0 1 1 .93-.367A4.975 4.975 0 0 0 10 14.996c2.065 0 3.89-1.24 4.65-3.16ZM7 5.996a1 1 0 1 1-.002 2.001A1 1 0 0 1 7 5.996Zm6 0a1 1 0 1 1-.002 2.001A1 1 0 0 1 13 5.996Z"
      />
    </Svg>
  )
}
